import { createI18n } from 'vue-i18n'
import fr from '@/locales/fr.json'
import timelineFr from '@vue-unistra/timelinejs/fr.json'
import en from '@/locales/en.json'
import timelineEn from '@vue-unistra/timelinejs/en.json'

const appLocale = import.meta.env.VITE_APP_I18N_LOCALE

const locale =
  import.meta.env.NODE_ENV === 'test'
    ? appLocale
    : (localStorage.getItem('octantLocale') ?? navigator.language.split('-')[0] ?? appLocale)

export default createI18n({
  locale,
  fallbackLocale: appLocale,
  warnHtmlInMessage: 'off',
  warnHtmlMessage: false,
  messages: {
    fr: {
      ...fr,
      ...timelineFr,
    },
    en: {
      ...en,
      ...timelineEn,
    },
  },
})
